import axios from "axios";

const authAxios = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/auth`,
  // Must time out: token refresh runs through this instance. Without a timeout a
  // slow/hung /auth/refresh_token leaves isRefreshing stuck true forever, which
  // queues every subsequent API request indefinitely and trips "Request timeout".
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

export default authAxios